import { atom, useAtom } from "jotai";
import { useCallback } from "react";
import { fetchTableDetails } from "../../api/tableQR/table";

const defaultTableDetails = atom({});
export const useTableDetails = () => {
  const [details, setDetails] = useAtom(defaultTableDetails);
  const updateDetails = useCallback(async (tableId) => {
    await getTableDetails(tableId);
  }, []);

  const getTableDetails = async (tableId) => {
    try {
      const response = await fetchTableDetails({
        params: {
          tableId,
        },
      });
      setDetails(response?.data);
    } catch (err) {
      console.log(err, "TABLE DETAILS ERROR");
    }
  };

  return {
    details,
    updateDetails,
  };
};
